



































import { Component, Vue } from 'vue-property-decorator';
import { Prop, Watch } from 'vue-property-decorator';
import Axios, { AxiosError, AxiosResponse } from 'axios';

@Component({
})
export default class Search extends Vue {
  readonly suggestionsUri = 'https://autocomplete.search.hereapi.com/v1/autocomplete';

  @Prop({ default: [] })
  readonly categories!: {uid: number, name: string}[];

  @Prop({ default: '' })
  readonly searchUrl!: string;

  @Prop({ default: '' })
  readonly apiKey!: string;

  @Prop({ default: 1 })
  readonly currentPage!: number;

  @Prop({ default: [] })
  readonly selectedCategories!: number[];

  selectedCategory: number = 0;

  searchTerm = '';

  isLoading = false;

  suggestions: any = [];

  selectedSuggestion: any = null;

  pageChanged = false;

  onSuggestionSelected(event: any) {
    this.selectedSuggestion = event;
  }

  get suggestionsCssClass(): string {
    if (this.canSelectCategories) {
      return 'col-md-3'
    }

    return 'col-md-9';
  }

  get canSelectCategories() {
    return this.filteredCategories.length > 1;
  }

  get filteredCategories() {
    if (!this.selectedCategories.length) {
      return this.categories;
    }

    return this.categories.filter((c) =>  this.selectedCategories.includes(c.uid));
  }

  mounted() {
    if (this.selectedCategories.length === 1) {
      this.selectedCategory = this.selectedCategories[0];
      this.onSubmit();
    }
  }

  @Watch('searchTerm')
  async onSearchTermChanged(term: string) {
    if (!term) {
      this.selectedSuggestion = null;
    }
    try {
      const result: AxiosResponse<any> = await Axios.get(this.suggestionsUri, {
        params: {
          apiKey: this.apiKey,
          q: term,
          in: 'countryCode:DEU',
          lang: 'de',
        }
      });

      if (result.data.hasOwnProperty('items')) {
        this.suggestions = result.data.items;
      } else {
        this.suggestions = [];
      }
    } catch (error) {
      this.suggestions = [];
    }
  }

  @Watch('currentPage')
  async onCurrentPageChanged() {
    this.pageChanged = true;
    await this.onSubmit();
    this.pageChanged = false;
  }

  async onSubmit() {
    this.isLoading = true;
    const formData = new FormData();
    formData.append('tx_dalzgaddresses_ajax[zipCity]', this.searchTerm);
    formData.append('tx_dalzgaddresses_ajax[category]', this.selectedCategory.toString());
    if (this.pageChanged) {
      formData.append('tx_dalzgaddresses_ajax[page]', this.currentPage.toString());
    } else {
      formData.append('tx_dalzgaddresses_ajax[page]', '1');
    }

    if (this.selectedSuggestion !== null) {
      formData.append('tx_dalzgaddresses_ajax[locationId]', this.selectedSuggestion.id);
    }

    try {
      const result: AxiosResponse<any> = await Axios.post(this.searchUrl, formData);
      this.$emit('search-result', result.data)
    } catch (error) {
    }
    this.isLoading = false;
  }
}
